import _extends from "@babel/runtime/helpers/extends";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { BackdropLoader, BasicTooltip, Box, Icon
// toast,
} from '@livable/saas-react-components';
import { Button, Container, Grid, Paper, Typography } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import BreadcrumbsBar from 'src/components/general/BreadcrumbsBar';
// import RangeDatePicker from 'src/components/general/RangeDatePicker';
import { USER_SETTINGS_KEYS } from 'src/constants/userSetting';
import { useStore } from 'src/stores';
import SendReportModal from './SendReportModal';
import useARPageStyles from './styles';
export default function ARPage() {
  const history = useLocation();
  const classes = useARPageStyles();
  const store = useStore();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const parameters = new URLSearchParams(history.search);
  const propertyId = parameters.get('propertyId');
  const _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isLoading = _useState2[0],
    setIsLoading = _useState2[1];
  const getCompanyTeamMembers = async () => {
    const resp = await store.teamMembers.getCompanyTeamMembersAsync.run({
      companyId: localStorage.getItem(USER_SETTINGS_KEYS.company)
    });
    return resp;
  };
  const getCompanyPropertyList = async () => {
    const resp = await store.company.getCompanyPropertyListAsync.run();
    return resp;
  };
  const getPropertyReport = async () => {
    const resp = await store.report.getPropertyReportAsync.run({
      propertyId
    });
    return resp;
  };
  useEffect(() => {
    setIsLoading(true);
    Promise.all([getCompanyPropertyList(), getCompanyTeamMembers(), getPropertyReport()]).finally(() => setIsLoading(false));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const getText = (p, showSign) => p === null || p === '' ? 'N/A' : "".concat(showSign ? '$' : '').concat(p);
  const renderCell = _ref => {
    let _ref$left = _ref.left,
      left = _ref$left === void 0 ? false : _ref$left,
      parameter = _ref.parameter,
      _ref$showSign = _ref.showSign,
      showSign = _ref$showSign === void 0 ? false : _ref$showSign;
    return /*#__PURE__*/React.createElement("span", {
      className: "".concat(classes.cellContent, " ").concat(left && classes.cellLeft)
    }, getText(parameter, showSign));
  };
  const renderTooltipCell = (parameter, left) => /*#__PURE__*/React.createElement(BasicTooltip, {
    title: parameter,
    placement: "top-start"
  }, /*#__PURE__*/React.createElement("span", {
    className: "".concat(classes.cellContent, " ").concat(classes.dotsOverflow, " ").concat(left && classes.cellLeft)
  }, getText(parameter)));
  const renderHeader = (text, rightAlign) => /*#__PURE__*/React.createElement("span", {
    className: rightAlign && classes.rightAlign
  }, text);
  const breadcrumbArray = [{
    title: t('reporting.reports'),
    link: '/reporting'
  }, {
    title: t('reporting.ar_summary_report')
  }];
  const columns = [{
    align: 'right',
    field: 'unitName',
    renderCell: params => renderTooltipCell(params.row.unitName, true),
    renderHeader: () => renderHeader(t('reporting.unit_name')),
    width: 100,
    sortComparator: (v1, v2) => {
      var _ref2;
      return (_ref2 = '' + v1) === null || _ref2 === void 0 ? void 0 : _ref2.localeCompare(v2, undefined, {
        numeric: true
      });
    }
  }, {
    align: 'right',
    field: 'residentFullName',
    renderCell: params => renderTooltipCell(params.row.residentFullName, true),
    renderHeader: () => renderHeader(t('reporting.resident_name')),
    width: 230
  }, {
    align: 'right',
    field: 'phoneNumber',
    renderCell: params => renderCell({
      left: true,
      parameter: params.row.phone
    }),
    renderHeader: () => renderHeader(t('reporting.phone_number')),
    width: 120
  }, {
    align: 'right',
    field: 'email',
    renderCell: params => renderTooltipCell(params.row.emailAddress, true),
    renderHeader: () => renderHeader(t('general.email')),
    width: 210
  }, {
    align: 'right',
    field: 'currentPeriod',
    headerAlign: 'right',
    renderCell: params => renderCell({
      parameter: params.row.currentPeriod,
      showSign: true
    }),
    renderHeader: () => renderHeader(t('reporting.current_cycle')),
    width: 100
  }, {
    align: 'right',
    field: 'dayMonthPeriod',
    headerAlign: 'right',
    renderCell: params => renderCell({
      parameter: params.row.dayMonthPeriod,
      showSign: true
    }),
    renderHeader: () => renderHeader(t('reporting.one_thirty_days')),
    width: 100
  }, {
    align: 'right',
    field: 'oneMonthTwoMonthPeriod',
    headerAlign: 'right',
    renderCell: params => renderCell({
      parameter: params.row.oneMonthTwoMonthPeriod,
      showSign: true
    }),
    renderHeader: () => renderHeader(t('reporting.thirty_sixty_days')),
    width: 100
  }, {
    align: 'right',
    field: 'twoMonthThreeMonthPeriod',
    headerAlign: 'right',
    renderCell: params => renderCell({
      parameter: params.row.twoMonthThreeMonthPeriod,
      showSign: true
    }),
    renderHeader: () => renderHeader(t('reporting.sixty_ninety_days')),
    width: 100
  }, {
    align: 'right',
    field: 'moreThreeMonthPeriod',
    headerAlign: 'right',
    renderCell: params => renderCell({
      parameter: params.row.moreThreeMonthPeriod,
      showSign: true
    }),
    renderHeader: () => renderHeader(t('reporting.ninety_one_and_over')),
    width: 120
  }, {
    align: 'right',
    field: 'total',
    headerAlign: 'right',
    renderCell: params => renderCell({
      parameter: params.row.total,
      showSign: true
    }),
    renderHeader: () => renderHeader(t('reporting.total')),
    width: 100
  }];
  const handleDownloadReport = async e => {
    e.stopPropagation();
    const getFileName = headers => {
      var _headers$fileName;
      return (_headers$fileName = headers['file-name']) !== null && _headers$fileName !== void 0 ? _headers$fileName : null;
    };
    const _await$store$report$d = await store.report.downloadPropertyReportAsync.run({
        propertyId
      }),
      downloadedFile = _await$store$report$d.data,
      headers = _await$store$report$d.headers;
    const encodedUri = window.URL.createObjectURL(new Blob([downloadedFile], {
      type: 'application/octet-stream'
    }));
    let link = document.createElement('a');
    link.setAttribute('href', encodedUri);
    link.setAttribute('download', getFileName(headers));
    document.body.appendChild(link);
    link.click();
    link.parentNode.removeChild(link);
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(BreadcrumbsBar, {
    breadcrumbsArray: breadcrumbArray
  }), /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(BackdropLoader, {
    isOpen: isLoading
  }), /*#__PURE__*/React.createElement(Container, {
    className: classes.pageContainer
  }, /*#__PURE__*/React.createElement(Paper, null, /*#__PURE__*/React.createElement("div", {
    className: classes.tableHeaderContainer
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.tableHeader
  }, /*#__PURE__*/React.createElement(Icon, {
    fontSize: "huge",
    type: "statistics"
  }), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Typography, {
    variant: "h4"
  }, t('reporting.ar_summary_report')), /*#__PURE__*/React.createElement(Typography, {
    variant: "h6",
    color: "light"
  }, store.company.getCompanyPropertyAddress(propertyId)))), /*#__PURE__*/React.createElement("div", {
    className: classes.actionButtons
  }, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    rowSpacing: 10,
    columnSpacing: 10
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    md: true
  }, /*#__PURE__*/React.createElement(Button, {
    onClick: e => handleDownloadReport(e),
    variant: "actionButton",
    'custom-attribute': '8-ar-page'
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "file-download"
  }), /*#__PURE__*/React.createElement("span", {
    className: "actionText"
  }, t('reporting.download_report')))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    md: true
  }, /*#__PURE__*/React.createElement(SendReportModal, {
    properties: store.company.companyPropertyList
  }))))), /*#__PURE__*/React.createElement(DataGrid, {
    initialState: {
      sorting: {
        sortModel: [{
          field: 'unitName',
          sort: 'asc'
        }]
      }
    },
    rows: store.report.propertyReports,
    columns: columns,
    pagination: true,
    disableRowSelectionOnClick: true,
    autoHeight: true,
    columnHeaderHeight: 52,
    pageSize: 10,
    rowsPerPageOptions: [5, 10, 20],
    rowHeight: 55,
    getRowClassName: () => classes.row,
    slots: {
      BaseButton: props => /*#__PURE__*/React.createElement(Button, _extends({}, props, {
        variant: "actionButton",
        'custom-attribute': '9-ar-page'
      })),
      BaseTextField: props => /*#__PURE__*/React.createElement(TextField, _extends({}, props, {
        variant: "outlined"
      }))
    },
    slotProps: {
      filterPanel: {
        filterFormProps: {
          columnInputProps: {
            variant: 'outlined'
          },
          operatorInputProps: {
            variant: 'outlined'
          }
        }
      }
    }
  })))));
}